export default __webpack_public_path__ + "static/media/0005.e1ea2f21.svg";